import { z } from 'zod';

export const NotificationPreferencesModalSchema = z.object({
  availabilityNotification: z.boolean().nullable(),
  benchNotification: z.boolean().nullable(),
  marketingCommunications: z.boolean().nullable(),
});

export type NotificationPreferencesModal = z.infer<
  typeof NotificationPreferencesModalSchema
>;
